import { gql } from '@apollo/client'
import { ProjectItemFragments } from '../fragments/projectItem.fragments'

export const GetProjectsQuery = gql`
    query getProjectsQuery($input: GetResultsInput!) {
        getProjects(input: $input) {
            count
            projects {
                ...recentlyViewedAndAllProjects
            }
            facets {
                name
                values
            }
            projectGroupCounts {
                groupId
                totalCount
            }
        }
    }
    ${ProjectItemFragments.RecentlyViewedAndAllProjects}
`

export const RecentlyViewedProjectsQuery = gql`
    query getRecentlyViewedProjectsQuery {
        getRecentlyViewedProjects {
            ...recentlyViewedAndAllProjects
        }
    }
    ${ProjectItemFragments.RecentlyViewedAndAllProjects}
`

export const GetProjectQuery = gql`
    query getProjectQuery($projectId: String!) {
        getProject(projectId: $projectId) {
            ...projectDetails
            id
            projectSettings {
                collectData
                familyNumberFormat
                unitOfMeasure
                elementTreeView
            }
            publishSettings {
                notesToSpecifier
                bookmarks
                cover
                excludeSectionTitle
                excludeTermSection
                exportAsDocx
                exportAsFullManual
                exportAsIndividualFiles
                exportAsPDF
                fontColorsOn
                hyperlinksActive
                includeFolderForDivision
                notesToSpecifier
                prefixWithSectionFileNamesWithSection
                revisionHistory
                widowOrphanControl
                includeTrackChanges
            }
            projectStyles {
                ...projectStyles
            }
            projectHeaderAndFooters {
                ...projectHeaderAndFooters
            }
        }
    }

    ${ProjectItemFragments.ProjectStyles}
    ${ProjectItemFragments.ProjectDetails}
    ${ProjectItemFragments.ProjectHeaderAndFooters}
`
export const GetProjectNotesQuery = gql`
    query getProjectNotesQuery(
        $projectId: String!
        $projectNoteSearchInput: ProjectNoteSearchInput!
    ) {
        getProject(projectId: $projectId) {
            ...projectDetails
            projectNotes(input: $projectNoteSearchInput) {
                id
                name
                description
                projectElementDescription
                noteType
                projectElementId
                noteBreadCrumbs
                metadata {
                    created
                    creatorId
                    updated
                }
                dueDate
                state
                comments {
                    id
                    text
                    metadata {
                        created
                        creatorId
                        updated
                    }
                }
            }
            projectSettings {
                collectData
                familyNumberFormat
                unitOfMeasure
            }
        }
    }
    ${ProjectItemFragments.ProjectDetails}
`
export const GetProjectElementsQuery = gql`
    query getProjectElementsQuery($input: GetProjectElementsResultsInput!) {
        getProjectElements(input: $input) {
            count
            projectElements {
                id
                dataType
                metadata {
                    updated
                }
                name
                projectElementMetadata {
                    assignedUser
                    targetLOD
                    currentLOD
                    state
                }
            }
        }
    }
`

export const GetProjectTeamQuery = gql`
    query getProjectTeamQuery($projectId: String!) {
        getProject(projectId: $projectId) {
            id
            projectTeam {
                ...projectTeam
            }
        }
    }
    ${ProjectItemFragments.ProjectTeam}
`
